export default __webpack_public_path__ + "static/media/Stall Icon.1dd03823.svg";